//External Libraries
import * as React from "react";
//Translations
import { Translate, injectIntl } from "../../localization/index";
//Styling
import "./PreLander.scss"


class PreLander extends React.PureComponent<{}> {
  state = {
  };
  render() {
    return (
      <div className="pre-lander-wrapper">
        <Translate id="pre-lander" defaultMessage="My Pre-Lander" />
      </div>
    );
  }
}

export default injectIntl(PreLander);